import { Groups, TeamMember } from "../../../types";

export enum TeamRoles {
  User = "teamMember",
  Administrator = "admin",
  Owner = "owner",
}

export enum TeamMemberStatus {
  Current = "Current",
  CurrentPending = "Current (Invite Pending)",
  Inactive = "Inactive",
}

export type OpenTeamMemberModal = {
  open: boolean,
  teamMember: TeamMember | null,
}

export type OpenTeamMemberAlert = {
  open: boolean,
  type: string,
  message: string,
}

export type AppUser = {
  key_?: number,
  login_user_id?: string,
  groups?: Partial<Groups>[],
  customer_number: string,
  firstname: string | null,
  middlename: string | null,
  lastname: string | null,
  email: string,
  access_level: TeamRoles,
  account_active: boolean,
  position: string,
  is_notification_team_member_editable: boolean,
  email_bio_failed: boolean,
  email_bio_passed: boolean,
  email_bio_child_failed?: boolean,
  email_waterline_failed: boolean,
  email_waterline_passed: boolean,
  email_waterline_child_failed?: boolean
}
